import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';

@Component({
    selector: 'edit-nota-controllo-modal',
    templateUrl: './edit-nota-modal.component.html',
    styleUrls: ['./edit-nota-modal.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None,
})
export class EditNotaModalComponent implements OnInit {
    annotazioni: string = '';

    constructor(@Inject(MAT_DIALOG_DATA) public data: string, public dialogRef: MatDialogRef<string>) {}

    ngOnInit() {
        this.annotazioni = this.data;
    }

    get confermaDisabled() {
        return !this.annotazioni || this.annotazioni.length === 0;
    }

    onConferma() {
        this.dialogRef.close(this.annotazioni);
    }
}
